import React from "react";
import SectionHeader from "./SectionHeader";
import { projects } from "../mock";
import { ArrowUpRight, FolderGit2, Github, ExternalLink } from "lucide-react";

const Projects = () => {
  return (
    <section id="projects" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          num="04 // CASE FILES"
          title="PROJECTS & LABS"
          subtitle="BUILT // BREACHED // DOCUMENTED"
        />
        <div className="grid md:grid-cols-2 gap-4">
          {projects.map((p) => (
            <div
              key={p.code}
              className="group relative border border-[#1c2533] bg-[#0c1118] p-6 card-hover flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <FolderGit2 size={14} className="text-cyan-400" />
                  <span className="font-mono text-[10px] tracking-[0.2em] text-cyan-400">
                    {p.code}
                  </span>
                  <span className="text-slate-700">//</span>
                  <span className="font-mono text-[10px] tracking-[0.18em] text-slate-400">
                    {p.type}
                  </span>
                </div>
                <ArrowUpRight
                  size={16}
                  className="text-slate-500 group-hover:text-cyan-400 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                />
              </div>

              <h3 className="font-mono font-bold text-lg md:text-xl text-slate-50 leading-snug mb-3 group-hover:text-cyan-400 transition-colors">
                {p.title}
              </h3>

              <p className="text-slate-400 text-[13.5px] leading-relaxed mb-5 flex-1">{p.desc}</p>

              <div className="flex flex-wrap gap-1.5 mb-5">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="font-mono text-[10px] tracking-[0.06em] text-slate-300 bg-[#0a0e14] border border-[#1c2533] px-2 py-0.5 rounded-sm"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <div className="pt-4 border-t border-[#1c2533] flex items-center justify-between gap-3 flex-wrap">
                <span className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                  STATUS: <span className="text-emerald-400">LIVE</span>
                </span>
                <div className="flex items-center gap-2">
                  {p.link && (
                    <a
                      href={p.link}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.18em] text-cyan-400 hover:text-cyan-300 border border-cyan-400/40 hover:border-cyan-400 px-2.5 py-1 rounded-sm transition-colors"
                    >
                      <ExternalLink size={11} /> LIVE DEMO
                    </a>
                  )}
                  {p.repo && (
                    <a
                      href={p.repo}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.18em] text-slate-300 hover:text-cyan-400 border border-[#2a3a52] hover:border-cyan-400 px-2.5 py-1 rounded-sm transition-colors"
                    >
                      <Github size={11} /> SOURCE
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
